"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemperatureInput = void 0;
const React = require("react");
const NumberInput_1 = require("../NumberInput");
const useTemperatureMetric_1 = require("../../../../hooks/useTemperatureMetric");
const fahrenheitToCelsius_1 = require("../../../../helpers/fahrenheitToCelsius");
const celsiusToFahrenheit_1 = require("../../../../helpers/celsiusToFahrenheit");
const valueToNumeric = (value, asCelsius) => {
    // try to coerce into a number
    const numValue = typeof value === "number"
        ? value
        : typeof value === "string" && value.length > 0
            ? parseFloat(value)
            : null;
    const convertedValue = numValue !== null ? (asCelsius ? value : (0, celsiusToFahrenheit_1.celsiusToFahrenheit)(value)) : null;
    return convertedValue;
};
class InnerTemperatureInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // the input value - kept seperate to the value prop due the conversion, which could cause an update cycle
            inputValue: valueToNumeric(props.value, props.asCelsius)
        };
        this.onTempChange = this.onTempChange.bind(this);
        this.lastValue = -1;
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        // avoid hearing our own updates
        if (newProps.value !== this.lastValue) {
            this.setState({
                inputValue: valueToNumeric(newProps.value, newProps.asCelsius)
            });
        }
    }
    onTempChange(value) {
        const parsedValue = this.props.asCelsius
            ? value
            : (0, fahrenheitToCelsius_1.fahrenheitToCelsius)(value);
        // keep the input up to date
        this.setState({ inputValue: value });
        // remember what we've reported
        this.lastValue = parsedValue;
        this.props.onInputChange(parsedValue);
    }
    render() {
        const _a = this.props, { asCelsius } = _a, rest = __rest(_a, ["asCelsius"]);
        return (React.createElement(NumberInput_1.NumberInput, Object.assign({}, rest, { value: this.state.inputValue, onInputChange: this.onTempChange, placeholder: asCelsius ? "Celsius" : "Fahrenheit" })));
    }
}
const TemperatureInput = props => {
    const asCelsius = (0, useTemperatureMetric_1.useTemperatureMetric)() === "metric";
    return React.createElement(InnerTemperatureInput, Object.assign({}, props, { asCelsius: asCelsius }));
};
exports.TemperatureInput = TemperatureInput;
//# sourceMappingURL=index.js.map